/** The Fahrtenbuch: business trips with Kilometergeld and Diäten (lib/at/travel.ts), posted by the ledger. */
import type { TripInput } from "@/lib/at/travel";
import type { TripsResponse } from "@/lib/platform/pb-types";
import { pb } from "@/lib/platform/pocketbase";

export type Trip = TripsResponse;

export type TripFields = {
  date: string;
  endDate: string;
  departureTime: string;
  returnTime: string;
  origin: string;
  destination: string;
  purpose: string;
  vehicle: Trip["vehicle"];
  distanceKm: number;
  odometerStart: number;
  odometerEnd: number;
  perDiem: boolean;
  meals: number;
  nights: number;
  notes: string;
};

export async function listTrips(workspaceId: string): Promise<Trip[]> {
  return pb.collection("trips").getFullList<Trip>({
    filter: pb.filter("workspace = {:workspaceId}", { workspaceId }),
    sort: "date,created",
  });
}

export async function createTrip(workspaceId: string, fields: TripFields): Promise<Trip> {
  return pb.collection("trips").create<Trip>({ ...fields, workspace: workspaceId });
}

export async function updateTrip(id: string, fields: Partial<TripFields>): Promise<Trip> {
  return pb.collection("trips").update<Trip>(id, fields);
}

/** The ledger reverses its entry; nothing is lost from the journal. */
export async function deleteTrip(id: string): Promise<void> {
  await pb.collection("trips").delete(id);
}

/** A stored trip as the travel rules read it. */
export function tripInput(trip: Trip): TripInput & { id: string } {
  return {
    id: trip.id,
    date: (trip.date ?? "").slice(0, 10),
    endDate: (trip.endDate ?? "").slice(0, 10) || undefined,
    departureTime: trip.departureTime || undefined,
    returnTime: trip.returnTime || undefined,
    vehicle: trip.vehicle,
    distanceKm: trip.distanceKm ?? 0,
    perDiem: Boolean(trip.perDiem),
    meals: trip.meals ?? 0,
    nights: trip.nights ?? 0,
  };
}
